'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const CloudIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M16.6053 18.5147H9.23691C5.67613 18.5147 2.78955 15.598 2.78955 12C2.78955 8.40199 5.67613 5.48523 9.23691 5.48523C11.8981 5.48523 14.1826 7.11431 15.1671 9.43934C15.6197 9.28918 16.1031 9.20795 16.6053 9.20795C19.1488 9.20795 21.2106 11.2914 21.2106 13.8613C21.2106 16.4314 19.1488 18.5147 16.6053 18.5147Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpCloudIcon = forwardRef(CloudIcon);

export { VpCloudIcon as default };
